<ng-container *ngIf="widgetVisible">
    <!--Widget source id is embedded for PDF exporting algorithm (backend) to be able to localize this container inside the document.-->
    <!--If view is PDF preview, an extra class is applied to change the styles of the view correspondingly.-->
    <div [id]="widgetSourceId"
         [class]="widgetContainerClass"
         [ngClass]="{'pdf-view': output === 'PDF'}">

        <div class="widget-control-set-topbar">
            <h2 *ngIf="!!widgetTitle?.length">{{ widgetTitle }}</h2>

            <!--This element is visible in web view only.-->
            <p-button *ngIf="exportable && output === 'web'"
                      styleClass="p-button-lg p-button-outlined p-button-text p-button-icon-only"
                      class="exporting-button" icon="pi pi-file-pdf" title="Export to PDF"
                      [loading]="pdfExportingLoading | async" (onClick)="generatePdf()">
            </p-button>
        </div>

        <div [class]="controlSetFiltersClass">
            <!--Web view of the widget control-set filters. This element is visible in web view only.-->
            <filter *ngIf="filterSettings && output === 'web'"
                    [settings]="filterSettings"
                    (filter)="onFilter($event)"
                    (filterChange)="onFilterChange($event)"
                    (filterSetChange)="restoreFiltersFromBackup($event)"></filter>

            <!--PDF view of the widget control-set filters. This element is visible in PDF view only.-->
            <!--It can be rendered hidden by demand, by setting renderPdfViewHidden to true.-->
            <div #pdfViewFilters *ngIf="renderPdfViewHidden || output === 'PDF'"
                 [ngClass]="{'pdf-view-hidden' : renderPdfViewHidden}"
                 class="widget-control-set-filters-container">

                <div *ngFor="let settings of filterSettings" class="widget-control-set-item">
                    <ng-container [ngSwitch]="settings.inputType">

                        <!-- Calendar -->
                        <span *ngSwitchCase="FilterInputType.Calendar" [class]="getFilterValue(settings)
                              ? 'widget-control-set-item-filled' : 'widget-control-set-item-empty'">
                            <label class="widget-control-set-value">
                                {{ getFilterValue(settings) ?? settings.header }}
                            </label>
                            <label class="widget-control-set-float-label">
                                {{ settings.header }}
                            </label>
                        </span>

                        <!-- Number -->
                        <span *ngSwitchCase="FilterInputType.Number" [class]="getFilterValue(settings)
                              ? 'widget-control-set-item-filled' : 'widget-control-set-item-empty'">
                            <label class="widget-control-set-value">
                                {{ getFilterValue(settings) ?? settings.header }}
                            </label>
                            <label class="widget-control-set-float-label">
                                {{ settings.header }}
                            </label>
                        </span>

                        <!-- Checkbox -->
                        <span *ngSwitchCase="FilterInputType.Checkbox" [class]="getFilterValue(settings)
                          ? 'widget-control-set-item-filled' : 'widget-control-set-item-empty'">
                            <div class="widget-control-set-checkbox">
                                <svg *ngIf="getFilterValue(settings)"
                                     width="14" height="14" viewBox="0 0 14 14" fill="none"
                                     class="p-checkbox-icon p-icon" aria-hidden="true">
                                    <path d="M4.86199 11.5948C4.78717 11.5923 4.71366 11.5745 4.64596 11.5426C4.57826
                                             11.5107 4.51779 11.4652 4.46827 11.4091L0.753985 7.69483C0.683167 7.64891
                                             0.623706 7.58751 0.580092 7.51525C0.536478 7.44299 0.509851 7.36177 0.502221
                                             7.27771C0.49459 7.19366 0.506156 7.10897 0.536046 7.03004C0.565935 6.95111
                                             0.613367 6.88 0.674759 6.82208C0.736151 6.76416 0.8099 6.72095 0.890436
                                             6.69571C0.970973 6.67046 1.05619 6.66385 1.13966 6.67635C1.22313 6.68886
                                             1.30266 6.72017 1.37226 6.76792C1.44186 6.81567 1.4997 6.8786 1.54141
                                             6.95197L4.86199 10.2503L12.6397 2.49483C12.7444 2.42694 12.8689 2.39617
                                             12.9932 2.40745C13.1174 2.41873 13.2343 2.47141 13.3251 2.55705C13.4159
                                             2.64268 13.4753 2.75632 13.4938 2.87973C13.5123 3.00315 13.4888 3.1292
                                             13.4271 3.23768L5.2557 11.4091C5.20618 11.4652 5.14571 11.5107 5.07801
                                             11.5426C5.01031 11.5745 4.9368 11.5923 4.86199 11.5948Z"
                                          fill="currentColor">
                                    </path>
                                </svg>
                            </div>
                            <label>{{ settings.header }}</label>
                        </span>

                        <!-- Dropdown -->
                        <span *ngSwitchCase="FilterInputType.Dropdown" [class]="getFilterValue(settings)
                              ? 'widget-control-set-item-filled' : 'widget-control-set-item-empty'">
                            <label class="widget-control-set-value">
                                {{ getFilterValue(settings) ?? settings.header }}
                            </label>
                            <label class="widget-control-set-float-label">
                                {{ settings.header }}
                            </label>
                        </span>

                        <!-- Multiselect -->
                        <span *ngSwitchCase="FilterInputType.Multiselect" [class]="getFilterValue(settings)
                              ? 'widget-control-set-item-filled' : 'widget-control-set-item-empty'">
                            <label class="widget-control-set-value">
                                {{ getFilterValue(settings) ?? settings.header }}
                            </label>
                            <label class="widget-control-set-float-label">
                                {{ settings.header }}
                            </label>
                        </span>

                        <!-- Text -->
                        <span *ngSwitchDefault [class]="getFilterValue(settings)
                              ? 'widget-control-set-item-filled' : 'widget-control-set-item-empty'">
                            <label class="widget-control-set-value">
                                {{ getFilterValue(settings) ?? settings.header }}
                            </label>
                            <label class="widget-control-set-float-label">
                                {{ settings.header }}
                            </label>
                        </span>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>